import {FormControl, FormGroup} from '@angular/forms';
import {PartnerContact} from '../models/partner-contact';

export abstract class ContactForm {
  static getFormGroup(): FormGroup {
    return new FormGroup({
      email: new FormControl(''),
      phoneNumber: new FormControl(''),
      civility: new FormControl(''),
      firstname: new FormControl(''),
      lastname: new FormControl(''),
      nickname: new FormControl(''),
      telegram: new FormControl(''),
      teams: new FormControl(''),
    });
  }

  static update(form: FormGroup, contact: PartnerContact): void {
    form.patchValue({
      email: contact.email,
      phoneNumber: contact.phoneNumber,
      civility: contact.civility,
      firstname: contact.firstname,
      lastname: contact.lastname,
      nickname: contact.nickname,
      telegram: contact.telegram,
      teams: contact.teams,
    });
  }
}
